import { AssetPreview } from './AssetPreview'

export default AssetPreview
